
// const apiBase = `http://localhost:4321/`;
const apiBase = `https://hisab.blockadedefence.com:4321/`;
// const apiBase = `https://rjmd.pentesthouse.com:8081/`;
export { apiBase };